//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import UserInfoModule from 'app_components/modules/campus/user/userInfo'
import MyCoursesModule from 'app_components/modules/campus/academic/myCourses'
import ActivityCalendarModule from 'app_components/modules/campus/academic/activityCalendar'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../studentDashboardSidebarModule.scss'

// @ADD Component types
interface IStudentDashboardSidebarModuleLayoutProps {}

const StudentDashboardSidebarModuleLayout: React.FC<IStudentDashboardSidebarModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='student_dashboard_sidebar-component'>
      <div className="student-user-info" id="student_user_info">
        <UserInfoModule />
      </div>
      <div className="student-my-courses" id="student_my_courses">
        <MyCoursesModule />
      </div>
      <div className="student-activity-calendar">
        <ActivityCalendarModule />
      </div>
    </div>
  )
}

export default StudentDashboardSidebarModuleLayout
